import { NavItem } from '../../atoms/NavItems'
import { DotlessList } from './styles'

export const NavList = () => (
  <DotlessList>
    <NavItem name="So funktioniert's" url="#so-funktioniert" />
    <NavItem name="Blog" url="https://blog.surein.de/" />
  </DotlessList>
)
